import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './SidebarNavigation.module.css';
import { NextIcon, PrevIcon } from './icons';
export default function SidebarNavigation(_a) {
    var _b;
    var isHandoffOpen = _a.isHandoffOpen, onShowNext = _a.onShowNext, onShowPrevious = _a.onShowPrevious;
    var rightButtonClasses = cx(styles.wrapper, (_b = {},
        _b[styles.wrapperRight] = !isHandoffOpen,
        _b[styles.wrapperRightHandoffOpen] = isHandoffOpen,
        _b));
    return (React.createElement("div", null,
        React.createElement("div", { className: cx(styles.wrapper, styles.wrapperLeft) },
            React.createElement("div", { className: styles.previousButton, onClick: onShowPrevious },
                React.createElement(PrevIcon, null))),
        React.createElement("div", { className: rightButtonClasses },
            React.createElement("div", { className: styles.nextButton, onClick: onShowNext },
                React.createElement(NextIcon, null)))));
}
SidebarNavigation.propTypes = {
    isHandoffOpen: PropTypes.bool,
    onShowNext: PropTypes.func.isRequired,
    onShowPrevious: PropTypes.func.isRequired,
};
SidebarNavigation.propTypes = {
    isHandoffOpen: PropTypes.bool,
};
